export default function NotesIcon() {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_35038_14795'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='20'
        height='20'
      >
        <rect width='20' height='20' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_35038_14795)'>
        <path
          d='M1.875 4.79102V1.04102H5.625V2.29102H3.125V4.79102H1.875ZM16.875 4.79102V2.29102H14.375V1.04102H18.125V4.79102H16.875ZM1.875 18.9577V15.2077H3.125V17.7077H5.625V18.9577H1.875ZM14.375 18.9577V17.7077H16.875V15.2077H18.125V18.9577H14.375ZM5.625 14.9512C5.625 15.0154 5.65174 15.0741 5.70521 15.1275C5.75854 15.1809 5.81729 15.2077 5.88146 15.2077H14.1185C14.1827 15.2077 14.2415 15.1809 14.2948 15.1275C14.3483 15.0741 14.375 15.0154 14.375 14.9512V5.04747C14.375 4.98331 14.3483 4.92456 14.2948 4.87122C14.2415 4.81775 14.1827 4.79102 14.1185 4.79102H5.88146C5.81729 4.79102 5.75854 4.81775 5.70521 4.87122C5.65174 4.92456 5.625 4.98331 5.625 5.04747V14.9512ZM5.88146 16.4577C5.46049 16.4577 5.10417 16.3118 4.8125 16.0202C4.52083 15.7285 4.375 15.3722 4.375 14.9512V5.04747C4.375 4.6265 4.52083 4.27018 4.8125 3.97852C5.10417 3.68685 5.46049 3.54102 5.88146 3.54102H14.1185C14.5395 3.54102 14.8958 3.68685 15.1875 3.97852C15.4792 4.27018 15.625 4.6265 15.625 5.04747V14.9512C15.625 15.3722 15.4792 15.7285 15.1875 16.0202C14.8958 16.3118 14.5395 16.4577 14.1185 16.4577H5.88146ZM7.70833 8.12435H12.2917V6.87435H7.70833V8.12435ZM7.70833 10.6243H12.2917V9.37435H7.70833V10.6243ZM7.70833 13.1243H12.2917V11.8743H7.70833V13.1243ZM5.625 14.9512V4.79102V15.2077V14.9512Z'
          fill='#09090A'
        />
      </g>
    </svg>
  );
}
